<template>
    <div class="col-md-12">
        <button class="btn btn-success btn-add" @click="openModal()">
            <i class="fas fa-bolt"></i> Adicionar nova mensagem rápida
        </button>

        <b-row>
            <b-col md="12">
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 class="empty-message">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(preview)="data">
                        <span class="message-preview" v-html="data.item.message"></span>
                    </template>

                    <template #cell(groups)="data">
                        <span
                            v-if="data.item.groups && data.item.groups.length > 0"
                            v-for="group in data.item.groups"
                            :key="group.id"
                            class="badge badge-group"
                        >
                            {{ group.name }}
                        </span>
                        <span v-else class="badge badge-all-groups">Todos os grupos</span>
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn class="btn-view" @click.prevent="openModal(item)">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group
                    label="Registros por página"
                    label-for="per-page-select"
                    label-cols-md="6"
                    label-align-sm="right"
                    label-size="sm"
                    class="mb-0 align-self-center"
                >
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <QuickMessageModal ref="addQuickMessage" @updateTable="updateTable" @deleteItem="removeFromTable"></QuickMessageModal>
    </div>
</template>

<script>
import axios from 'axios';
import QuickMessageModal from './QuickMessageModal.vue';

export default {
    name: "QuickMessagesTable",
    components: { QuickMessageModal },
    data() {
        return {
            tbData: [],
            loading: false,
            fields: [
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'preview',
                    label: 'Prévia da Mensagem',
                    sortable: false,
                    class: 'text-left',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'groups',
                    label: 'Grupos',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        openModal(value = null) {
            this.$refs.addQuickMessage.openModal(value);
        },
        refresh() {
            this.getDataTable();
        },
        getDataTable() {
            this.loading = true;
            axios.get("/settings/quick-messages")
                .then(response => {
                    this.tbData = response.data;
                    this.totalRows = response.data.length;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateTable(data) {
            if (!data.id) return;
            const found = this.tbData.find(el => el.id === data.id);
            if (found) {
                Object.assign(found, data);
            } else {
                this.tbData.push(data);
                this.totalRows = this.tbData.length;
            }
            this.$emit('changed');
        },
        removeFromTable(id) {
            this.tbData = this.tbData.filter(el => el.id !== id);
            this.totalRows = this.tbData.length;
            this.$emit('changed');
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    }
}
</script>

<style scoped>
.btn-add {
    border-radius: 2px;
}

.empty-message {
    text-align: center;
}

.btn-view {
    border-radius: 3px;
}

.badge-group {
    margin: 0 4px;
    font-size: 0.85em;
    background-color: #dc3545;
    color: #ffffff;
}

.badge-all-groups {
    margin: 0 4px;
    font-size: 0.85em;
    background-color: #6c757d;
    color: #ffffff;
}

.message-preview {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-width: 360px;
    font-size: 0.9em;
    color: #444;
}
</style>